import React, { useCallback } from 'react';
import { WysiwygV1 } from '../../UiKit/wysiwyg/WysiwygV1';

export default function TextEditor({
  field,
  inputKey,
  saveOptions,
  errors,
  isEditable,
  styleClasses,
  hideSaveButton,
}) {
  const getContentData = useCallback(
    (value) => {
      saveOptions(inputKey, value);
    },
    [saveOptions],
  );
  return (
    <div className={`${styleClasses}`}>
      <WysiwygV1
        value={field?.value || ''}
        error={errors}
        onChange={getContentData}
        readOnly={!isEditable}
        hideSaveButton={hideSaveButton}
      />
    </div>
  );
}
